import { setCoordinate } from '../map';
import { updateUrl } from '../../lib/url';

/**
 * Set coordinate.
 * @param {!object} coordinate A coordinate.
 * @param {bool} isUpdateUrl should url be updated.
 * @return {function} action dispatcher.
 */
export default (
    coordinate,
    isUpdateUrl = true,
) => async (dispatch, getState) => {
  dispatch(setCoordinate(coordinate));

  if (isUpdateUrl) {
    updateUrl(getState());
  }
};
